import type { FaireProductEntity } from "../../entity_types/product";

export const p_r4u2rj7s3w: FaireProductEntity = {
  token: "p_r4u2rj7s3w",
  type: "product",
  name: "Single breasted loose striped cardigan knit coat",
  brandToken: "b_m8aq2q3qv8",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/676901bdd10ad5f9581580b5c8735627f79f29f3e282311790126f761332a031.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/50dec4685243a713b0680a725f506f04c9a1ead5cb6542b24333d5f576bceaa7.jpeg",
    "https://cdn.faire.com/fastly/b7cba744ed71add044336bfe75c1b14b0871075055ae43764a7bd028b35cef17.jpeg",
    "https://cdn.faire.com/fastly/6e58cfd6da8859d1cd9e9195dc5fb6cfdd4a9cdc024d3df9f8752a7b0e15d5e8.jpeg",
    "https://cdn.faire.com/fastly/d88f2d95fa5a5f9ab67e0448b12759b1beb18d7bad83313dee6d9b03e2ef60cb.jpeg",
    "https://cdn.faire.com/fastly/42a6dc90328294802059c98ad4419baa1edb9e776f00f5c2d56fddcfd1376e1a.jpeg",
    "https://cdn.faire.com/fastly/d8974b80735ad1f6ae5b093a342f387aa93ba110b6bc5cb4f022cabb596ee965.jpeg",
    "https://cdn.faire.com/fastly/d0aa1746db5bd9bb4c040eb086098f43dcb4419a8fe10b4690ec978b31b94e6b.jpeg",
    "https://cdn.faire.com/fastly/32037307fea793aef1dddcf93f023dbaa4088460a7785eafeac0784a0af03d0a.jpeg",
    "https://cdn.faire.com/fastly/3f68ec0db832c83dea9524bb58ecfcd97abbf6bd12a545ff6a244ec767ae563d.jpeg",
    "https://cdn.faire.com/fastly/5649aec36108bb3c22feec495ef518e6885096207d138c66209ff1385634f5ad.jpeg",
    "https://cdn.faire.com/fastly/61b2a26a43c59bfdd957a2661e9bac0956032c705b675c71ff8a6653e349cd21.jpeg",
    "https://cdn.faire.com/fastly/f03aba0d2318f7b971699e0b6ae6f19de494ea52edb58301d06d0aa1a3f33b86.jpeg",
    "https://cdn.faire.com/fastly/ea28c583579d62b9f8accae61a5921dfdc769aff0e7ecb6e799512ac53b5d6d6.jpeg",
    "https://cdn.faire.com/fastly/9de26e189b321b4ab69afe551995973ee70c9633b7d26992b62e09575e168155.jpeg",
  ],
  priceDollars: 28.73,
  description:
    "Single breasted loose striped cardigan knit coat\n100% ACRYLIC\nSIZE: S,M,L,XL\nMADE IN CHINA\n\nCardigan, women's cardigan, cardigan, large size cardigan, knitted cardigan, oversized cardigan, cardigan hoodie, summer cardigan, short cardigan, long cardigan, spring cardigan, 2024 new cardigan, winter cardigan, fashionable women's cardigan, cardigan shirt, cardigan button down cardigan, loose cardigan, summer cardigan, knitted outerwear, cardigan with pockets，cardigan sweater，mens cardigan，folklore cardigan，black cardigan，red cardigan，white cardigan，womens cardigan，cropped cardigan，       crochet cardigan，long cardigan，cashmere cardigan，granny square cardigan，oversized cardigan，knit cardigan，womens cardigan sweaters，chunky cardigan，gray cardigan，long cardigan clothing，lightweight cardigan，cropped cardigan sweater，crochet cardigan pattern",
  tags: [],
  msrpDollars: 57.45,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:23.505Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
